import { EScreenType, IDesignDto, IDisplayItem } from "../../index";

export interface IScreenDesignDto extends IDesignDto {
  kComponentSet_Id: string;
  kProject_Id: string;
  lastMajorVersion: number;
  lastVersion: number;
  publicJson?: string;
  inUseData: IScreenDesignInUseData;
}

export interface IScreenDesignInUseData {
  isScreenInUse: boolean;
  screenName: string;
  usingBy: string;
  alternativeSdList: ISdAlternative[];
}

export interface ISdAlternative {
  id: string;
  name: string;
}

export enum ECRUDDataSourceType {
  Table = 1,
  Custom = 2,
  Excel = 3
}

export enum ECRUDFormNavigationType {
  Modal = 1,
  Drawer = 2,
  CurrentPage = 3
}

export enum ECRUDFormLayoutType {
  SingleColumn = 1,
  TwoColumn = 2,
  FourColumn = 3
}

// export enum ECRUDDeletionType
// {
//     PhysicalDelete = 1, // Hard Delete
//     LogicalDelete = 2 // Soft Delete
// }

export interface ICRUDGetFormDiRequest {
  formLayoutType: ECRUDFormLayoutType;
  actionDefinitionId: string;
  projectId: string;
  actionInputType: EActionInputType;
  visibleOptionalParameters: string[];
}

export interface ICRUDGetWfBoFormDiRequest {
  projectId: string;
  processId: string;
  selectedStepId: string;
  formLayoutType: ECRUDFormLayoutType;
}

export interface ICRUDGetTableDiRequest {
  projectId: string;
  actionDefinitionId: string;
}

export enum EGalleryViewType {
  OnlyImage = 1,
  ImageAndTextOnSide = 2,
  ImageAndTextOnBottom = 3
}

export interface ICRUDGetGalleryViewDiRequest {
  projectId: string;
  actionDefinitionId: string;
  galleryViewType: EGalleryViewType;
  imageFieldName: string;
  titleFieldName: string | null;
}

export enum ECRUDOutputType {
  Screen = 0,
  DisplayItem = 1
}

export enum EActionInputType {
  Parameters = 0,
  ReturnValue = 1
}

export interface ICRUDRequest {
  name: string; // crud değil global!
  projectId: string;
  dataSourceType: ECRUDDataSourceType;
  datasourceId: string; // Tablo seçili ise besleniyor, action seçili ise kullanılmamalı.
  tableName: string;
  tableSchema: string;
  selectActionId: string;
  getByIdActionId: string;
  createActionId: string;
  updateActionId: string;
  deleteActionId: string;
  navigationType: ECRUDFormNavigationType;
  formLayoutType: ECRUDFormLayoutType;
  hasListPage: boolean;
  hasSearchBar: boolean;
  hasPagination: boolean;
  hasCreate: boolean;
  hasUpdate: boolean;
  hasDeletion: boolean;
  hasView: boolean;
  leftMenuScreenId: string;
  outputType: ECRUDOutputType;
  responsiveLayoutSizes: IResponsiveLayoutSizes;
  screenType: EScreenType;
  // deletionType: ECRUDDeletionType; // TODO:turenc Daha sonra eklenecek, analiz sürecinde.
}

export interface ICRUDResponse {
  displayItem: IDisplayItem | null;
  outputType: ECRUDOutputType;
  screenId: string;
}

export interface ICRUDFormField {
  id: string;
  isEnabled: boolean;
  name: string;
  typeName: string;
  elementType: string;
  isRequired: boolean;
  isReadonlyField: boolean;
  predefinedIds?: IFormFieldPredefinedIds;
  attributes?: {
    [key: string]: string;
  };
  accompanyingDisplayItemPredefinedIds?: {
    [key: string]: number;
  };
  /**
   * @deprecated Use linkedColumnName instead. Won't work beyond Form version 2.
   * */
  linkedColumnId?: string;
  linkedColumnName?: string;
  linkedActionParameterName?: string;
  linkedActionReturnValueName?: string;
  linkedWorkflowBoParameterName?: string;
  linkedWorkflowBoParameterId?: string;
  decimalScale: number | null;
  source: EFormFieldSource;
  /**
   * Where a SelectBox / MultiSelect field gets its OPTIONS from.
   *
   * A field whose `elementType` is Select or MultiSelect renders a component with an
   * `options` property, and that property has to be bound to something or the dropdown
   * ships EMPTY. Until this declaration existed the only binding path was automatic and
   * table-driven (the backend binds only a field whose data type IS a database table), so a
   * workflow form — whose business-object parameter types are always primitives — could
   * never bind one.
   *
   * Absent (the default, and what every pre-existing metadata blob deserializes to) means
   * "not declared": binding is skipped and behaviour is byte-identical to before.
   *
   * EVERY member here admits `null`, not just `undefined`. The C# side serializes an unset
   * value as JSON `null`, so a field arriving from the server carries `optionsSource: null` —
   * an `=== undefined` check passes that straight through and the next property read throws.
   * Declaring `| null` makes the COMPILER find those instead of a white screen finding them.
   *
   * Keep in sync with `CRUDField.OptionsSource` in FormMetadataRequest.cs.
   */
  optionsSource?: ICRUDFieldOptionsSource | null;
}

/**
 * The two — and only two — things a component's `options` property can be bound to in this
 * platform. Mirrors the property panel's own source list ("Fixed Option List" + the actions
 * defined on the screen); there is no third kind. A database table is NOT a source: the CRUD
 * form path merely GENERATES a select action from a table and then binds the action.
 *
 * Keep in sync with `EFormFieldOptionsSourceKind` in FormMetadataRequest.cs.
 */
export enum EFormFieldOptionsSourceKind {
  /** Not declared — binding is skipped entirely. */
  None = 0,
  /** Hand-entered key/text pairs (Low / Medium / High …). */
  FixedList = 1,
  /** A list-returning action, run on the screen's page-init. */
  Action = 2
}

/**
 * A form field's declared options source. Resolved into the input display item's `options`
 * symbol at generation time by the backend form builder.
 *
 * Keep in sync with `CRUDFieldOptionsSource` in FormMetadataRequest.cs.
 */
export interface ICRUDFieldOptionsSource {
  kind: EFormFieldOptionsSourceKind;
  /** `Action` only: the action definition to bind to. */
  actionDefinitionId?: string | null;
  /**
   * `Action` only: the action's name, stored so the symbol's `actionDefinitionObjectPath`
   * can be written without a catalog lookup.
   */
  actionName?: string | null;
  /**
   * `FixedList` only: the hand-entered items. Serialized into the options symbol's
   * `fixedValue` as a JSON STRING of `[{"key":…,"text":…}]` — the shape the runtime
   * SelectBox and the existing `data-key-text-field-list` editor both expect. Kept as a
   * typed list here (and not as that JSON string) so this Top-risk shared schema stays
   * validatable instead of smuggling a second serialization format inside one of its fields.
   */
  fixedItems?: ICRUDFieldOptionsItem[] | null;
  /**
   * `Action` only: the returned column shown to the user. Becomes the options symbol's
   * `fieldToDisplay` (emitted as `datatextfield`). Ignored for a fixed list, which is always
   * keyed `key`/`text`.
   */
  fieldToDisplay?: string | null;
  /**
   * `Action` only: the returned column used as the stored value. Becomes the options symbol's
   * `fieldToUseAsKey` (emitted as `datavaluefield`), so its type must be assignable to the
   * parameter this field writes.
   */
  fieldToUseAsKey?: string | null;
}

/** One hand-entered option. Lower-case member names are the runtime contract. */
export interface ICRUDFieldOptionsItem {
  key: string;
  text: string;
}

export enum EFormFieldSource {
  // Custom is used for custom fields that are not mapped to any source.
  // Eg. User can add additional fields to a form that is synced with a table.
  Custom = 0,
  TableColumn = 1,
  ExcelColumn = 2,
  ActionParameter = 3,
  ActionReturnValue = 4,
  WorkflowBusinessObjectParameter = 5
}

export interface IResponsiveLayoutSizes {
  desktop: ECRUDFormLayoutType;
  tablet: ECRUDFormLayoutType;
  mobile: ECRUDFormLayoutType;
}

export interface IFormSectionPredefinedIds {
  sectionKuikaId: number;
  sectionHeaderRowKuikaId: number;
  sectionTitleCellKuikaId: number;
  sectionTitleKuikaId: number;
}

export interface IPredefinedFormFooterIds {
  footerRowKuikaId: number;
  footerColKuikaId: number;
  footerButtonKuikaId: number;
  footerHorizontalStackKuikaId: number;
  footerUserInteractionButtonsKuikaIds: { [key: string]: number };
}

export interface IFormFieldPredefinedIds {
  fieldCellKuikaId: number;
  labelKuikaId: number;
  inputKuikaId: number;
}

export interface IFormSection {
  id: string;
  title: string | null;
  items: ICRUDFormField[];
  responsiveLayoutSizes: IResponsiveLayoutSizes;
  predefinedIds?: IFormSectionPredefinedIds;
  /**
   * @deprecated Use IsReadonlyField instead. Obsolete starting metadata version 3.
   */
  isViewSection?: boolean;
}

export interface ICRUDGetFormDiCustomRequest extends ICRUDFormDiMetadata {
  projectId: string;
  currentDiSnapshot?: string;
}

export interface IMigrateFormMetadataRequest {
  metadata: ICRUDFormDiMetadata;
}

export interface ISyncFormMetadataWithTableRequest extends ICRUDFormDiMetadata {}

export interface ISyncFormMetadataWithWorkflowBoRequest extends ICRUDFormDiMetadata {}

export interface ISyncFormMetadataWithActionRequest extends ICRUDFormDiMetadata {}

export interface IGetFormMetadataFromExcelRequest {
  base64Str: string;
}

export interface IGetFormMetadataFromDataTableRequest {
  dataSourceId: string;
  tableName: string;
}

export interface IGetFormMetadataFromActionRequest {
  // formLayoutType: ECRUDFormLayoutType;
  actionDefinitionId: string;
  actionInputType: EActionInputType;
  responsiveLayoutSizes?: IResponsiveLayoutSizes;
  // visibleOptionalParameters: string[];
}

export interface IGetFormMetadataFromWorkflowBoRequest {
  processId: string;
  stepId: string;
  responsiveLayoutSizes?: IResponsiveLayoutSizes;
}

export interface IUnlinkFormFromSourceRequest extends ISyncFormMetadataWithTableRequest {}

export enum EFormSource {
  DataTable = 0,
  Action = 1,
  AI = 2,
  Custom = 3,
  Excel = 4,
  WorkflowBo = 5,
  DynamicEAV = 6
}

export interface ILinkedTable {
  tableId?: string;
  tableName: string;
}

export interface ICRUDFormLinkedAction {
  actionDefinitionId: string;
}

export interface CRUDFormLinkedWorkflowBo {
  processId: string;
  stepId: string;
}

export interface ICRUDFormDiMetadata {
  source: EFormSource;
  version: number;
  sections: IFormSection[];
  predefinedFormDiId?: number;
  predefinedFormFooterIds?: IPredefinedFormFooterIds;
  linkedTable?: ILinkedTable;
  linkedAction?: ICRUDFormLinkedAction;
  linkedWorkflowBo?: CRUDFormLinkedWorkflowBo;
}

// Keep in sync with CRUDInputElementConstants in CRUDRequest.cs
export class CRUDInputElementConstants {
  public static Auto = "auto";

  public static Checkbox = "Checkbox";

  public static ToggleSwitch = "Toggle Switch";

  public static PickerDate = "Picker Date";

  public static PickerDateTime = "Picker Date Time";

  public static InputNumeric = "Input Numeric";

  public static Currency = "Currency";

  public static Percent = "Percent";

  public static TextInput = "Text Input";

  public static TextArea = "Text Area";

  public static Password = "Password";

  public static Email = "Email";

  public static Url = "Url";

  public static Select = "Select";

  public static MultiSelect = "Multiselect List";

  public static ImageView = "Image View";

  public static Signature = "Signature";
}

export interface ICRUDSyncFormMetadataWithWorkflowResponse {
  metadata: ICRUDFormDiMetadata;
  processName: string;
  stepName: string;
}

export interface ICRUDSyncFormMetadataWithTableResponse {
  metadata: ICRUDFormDiMetadata;
}

export interface ICRUDSyncFormMetadataWithActionResponse {
  metadata: ICRUDFormDiMetadata;
}

export interface ICreateButtonRequest {
  name: string;
  label: string;
  textColor: string;
  backgroundColor: string;
  fontSize: number;
  lineHeight: number;
  isMultiLanguageLabelEnabled: boolean;
  labelsByLanguage: { name: string; value: string }[];
}
